export default "__VITE_ASSET__CHETvhc2__"